import {useSelector} from "react-redux";
import {StoreI} from "~src/rootReducer";
import {getContentLocale} from "~src/services/session";

export function useContentLocale(): string {
  return useSelector((state: StoreI) => getContentLocale(state));
}
